'use es6';

import { combineReducers } from 'redux';
import Auth from './Auth';
import GettingStarted from './GettingStarted';
import AcademyToSoftware from './AcademyToSoftware';
import Accounts from './Accounts';
import Wizard from './Wizard';
import Products from './Products';
export default combineReducers({
  accounts: Accounts,
  auth: Auth,
  gettingStarted: GettingStarted,
  academyToSoftware: AcademyToSoftware,
  wizard: Wizard,
  products: Products
});